<!-- 
  筛选组件
  props:
    item: 数据对象
    label: 是否显示筛选标题，默认显示
    advanced: 是否为高级筛选，默认false
 -->
 
<template>
  <div class="list-filter">
    <!-- 日期范围 -->
    <template v-if="item.fieldType === 4">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <el-date-picker
        unlink-panels
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        clearable
        v-model="arr"
        type="daterange"
        align="right"
        value-format="yyyy-MM-dd"
        :picker-options="pickerOptions"
        @change="handleSelect"
        size="small"
        style="padding:0 10px"
        >
      </el-date-picker>
    </template>
    <!-- 字符串 -->
    <template v-else-if="[1, 2, 7, 61].indexOf(item.fieldType) > -1 || item.attr === 'address' || item.attr === 'phone'">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <input type="text"
        class="v-input"
        v-model="str"
        @change="handleSelect"
        placeholder="输入关键词搜索">
      <i class="el-icon-close" v-if="str" @click="clearValue(item.attr)"></i>
    </template>
    <!-- 星星 -->
    <template v-else-if="item.fieldType === 10">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <el-select size="small" v-model="arr" multiple placeholder="请选择" @change="handleArr">
        <el-option
          v-for="s in star"
          :key="s.value"
          :label="s.label"
          :value="s.value">
        </el-option>
      </el-select>
    </template>
    <!-- 多选 -->
    <template v-else-if="item.fieldType === 3">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <el-select
        size="small"
        v-model="arr"
        @change="handleArr"
        multiple
        collapse-tags
        placeholder="请选择">
        <template v-if="item.valueArrMap">
          <el-option
            v-for="arr in item.valueArrMap"
            :key="arr.value"
            :label="arr.value"
            :value="arr.key">
          </el-option>
        </template>
        <template else>
          <el-option
            v-for="option in strToArr(item.initValue)"
            :key="option"
            :value="option">
          </el-option>
        </template>
      </el-select>
    </template>
    <!-- 单选 -->
    <template v-else-if="(item.fieldType === 9 || item.attr==='warehouseId')">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <el-select clearable
        size="small"
        v-model="str"
        @change="handleSelect"
        placeholder="请选择">
        <template v-if="item.valueArrMap">
          <el-option
            v-for="(label, value) in item.valueArrMap"
            :key="value"
            :label="label"
            :value="value">
          </el-option>
        </template>
        <template else>
          <el-option
            v-for="option in strToArr(item.initValue)"
            :key="option"
            :value="option">
          </el-option>
        </template>
      </el-select>
    </template>

    <!-- 产品分类筛选 -->
    <template v-else-if="item.attr === 'categoryId'">
      <div v-clickoutside="closeFilter">
        <label v-if="label" class="label">{{item.attrName}}:</label>
        <input type="text"
          class="v-input"
          readonly
          :value="selectCate4Show"
          @focus="showCategray"
          placeholder="请选择分类">
        <i class="el-icon-close" v-if="selectCate.length" @click="clearCate"></i>
        <div class="categray" v-if="categrayShow">
          <el-tree :data="categories"
            :props="defaultProps"
            show-checkbox
            @check-change="handleCheckChange">
          </el-tree>
        </div>
      </div>
    </template>

    <!-- 附近客户: 是否显示公海池客户 -->
    <template v-else-if="item.attr === 'isPublic'">
      <label v-if="label" class="label">{{item.attrName}}:</label>
      <el-switch
        v-model="showPublic"
        @change="handlePublic"
        active-text=""
        inactive-text=""
        active-color="#ff7c35">
      </el-switch>
    </template>
    <template v-else>
      <label v-if="label" class="label">{{item.attrName}}:</label>
    </template>
  </div>
</template>

<script>
import * as api from 'src/api'
import { mapActions } from 'vuex'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
let lazy

export default {
  props: {
    item: {
      type: Object
    },
    label: {
      type: Boolean,
      default: true
    },
    advanced: {
      type: Boolean,
      default: false
    }
  },
  created () {
    // 如果item有初始值，则执行筛选操作
    if (this.item.value) {
      this.$nextTick(() => {
        this.arr = this.item.value
      })
    }
  },
  data () {
    return {
      str: '',
      arr: [],
      showPublic: true, // 是否显示公海池客户
      star: [
        {
          label: '一星',
          value: 1
        },
        {
          label: '二星',
          value: 2
        },
        {
          label: '三星',
          value: 3
        },
        {
          label: '四星',
          value: 4
        },
        {
          label: '五星',
          value: 5
        }
      ],
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick (picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      categories: [],
      categrayShow: false,
      defaultProps: {
        children: 'childList',
        label: 'name'
      },
      selectCate: []
    }
  },
  computed: {
    // 用来显示的
    selectCate4Show () {
      return this.selectCate.map(item => item.name).join(',')
    },
    // 用来发送的
    cate4Send () {
      return this.selectCate.map(item => item.id)
    }
  },
  methods: {
    ...mapActions([
      'filterNormal',
      'filterAdvanced'
    ]),
    handleSelect (val) {
      if (this.item.fieldType === 4) {
        this.str = val || []
      }
      if (this.advanced) {
        this.filterAdvanced({
          key: this.item.attr,
          value: typeof this.str === 'string' ? this.str.trim() : this.str // this.str为字符串时需要去除首位空格，为数组不处理
        })
      } else {
        this.filterNormal({
          key: this.item.attr,
          value: typeof this.str === 'string' ? this.str.trim() : this.str // this.str为字符串时需要去除首位空格，为数组不处理
        })
      }
    },
    handleArr (arr) {
      if (this.advanced) {
        this.filterAdvanced({
          key: this.item.attr,
          value: this.arr
        })
      } else {
        this.filterNormal({
          key: this.item.attr,
          value: this.arr
        })
      }
    },

    // 监测是否显示公海池客户
    handlePublic () {
      this.$nextTick(() => {
        this.filterNormal({
          key: 'isPublic',
          value: this.showPublic
        })
      })
    },
    clearValue (attr) {
      this.str = ''
      this.handleSelect(attr)
    },
    strToArr (str) {
      if (str) {
        return str.split('|')
      }
      return []
    },
    getCategories () {
      let url = '/productApi/getProductCategoryAjax.html'
      api.post(url, {}, (data) => {
        // 批量替换 '&quot;' 为 '"'
        data.productCategoryList = JSON.parse(JSON.stringify(data.productCategoryList).replace(/&quot;/g, '\\"'))
        this.categories = data.productCategoryList
      })
    },
    showCategray () {
      this.getCategories()
      this.categrayShow = true
    },
    closeFilter () {
      this.categrayShow = false
    },
    // Tree选中事件
    handleCheckChange (obj, status) {
      if (status) {
        this.selectCate.push(obj)
      } else {
        let index
        this.selectCate.forEach((item, i) => {
          if (item.id === obj.id) index = i
        })
        if (index > -1) {
          this.selectCate.splice(index, 1)
        }
      }
      window.clearTimeout(lazy)
      lazy = window.setTimeout(() => {
        this.filterNormal({
          key: this.item.attr,
          value: this.cate4Send
        })
      }, 50)
    },
    clearCate () {
      this.selectCate = []
      this.filterNormal({
        key: this.item.attr,
        value: this.cate4Send
      })
    }
  },
  directives: { Clickoutside }
}
</script>

<style lang="less">
  @import '../../assets/less/variable.less';
  .list-filter {
    position: relative;
    .el-date-editor{
      position: relative;
      width: 100%;
      .el-range-input{
        font-size: 12px;
        height: 28px;
      }
      .el-input__icon {
        position: absolute;
        right: 3px;
        top: 0;
      }
      .el-range-separator {
        padding: 0 2px;
      }
      &:hover {
        .el-range__icon {
          display: none;
        }
      }
     }
    .label {
      display: inline-block;
      vertical-align: top;
      line-height: 30px;
      font-size: 13px;
      margin-right: 6px;
    }
    .label+div {
      display: inline-block;
      vertical-align: top;
      width: 130px;
    }
    .el-select {
      .el-select__tags {
        overflow: hidden;
        .el-tag {
          margin: 1px 0 1px 6px;
          height: 22px;
          line-height: 22px;
        }
      }
      .el-select__tags>span {
        white-space: nowrap;
        display: flex;
      }
    }
    .v-input {
      appearance: none;
      background-color: #fff;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      color: #1f2d3d;
      display: block;
      padding: 4px 8px;
      outline: none;
      line-height: 1;
      height: 32px;
      display: inline-block;
      box-sizing: border-box;
      transition: border-color 0.2s;
      font-size: 13px;
      &:focus {
        border-color: #008cee;
      }
    }
    .v-input+.el-icon-close {
      position: absolute;
      background-color: #fff;
      right: 10px;
      top: 10px;
      font-size: 12px;
      color: @primary;
      cursor: pointer;
      transform: scale(0.8);
    }
    .categray {
      z-index: 100;
      position: absolute;
      left: 62px;
      top: 32px;
      width: 300px;
      box-shadow: 0 0 4px 0 rgba(137, 137, 137, 0.5);
      max-height: 460px;
      overflow: auto;
    }
    .el-switch {
      margin-top: 4px;
    }
  }
  .list-panel, .commun-panel {
    .list-filter {
      .el-date-editor {
        width: 198px;
      }
    }
  }
</style>


// WEBPACK FOOTER //
// filter.vue?31ce61fa